import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

/* ─── Types ──────────────────────────────────────────────────────────── */

/* GET /feedback-ratings is a global feed — no per-user scoping on this API. */
interface GetCallingFeedbacksParams {
  search?: string;
  page?:   number;
  limit?:  number;
}

interface AddCallingFeedbackArgs {
  rating:      number;
  description: string;
  name:        string;
}

/* ─── API ────────────────────────────────────────────────────────────── */

export const callingFeedbackApi = createApi({
  reducerPath: 'callingFeedbackApi',
  baseQuery:   dynamicBaseQuery,
  tagTypes:    ['CallingFeedback'] as const,
  endpoints:   (builder) => ({
    getCallingFeedbacks: builder.query<unknown, GetCallingFeedbacksParams | void>({
      query: (params) => {
        const { search, page, limit } = params || {};
        const qp = new URLSearchParams();
        if (search)        qp.append('search', search);
        if (page  != null) qp.append('page', String(page));
        if (limit != null) qp.append('limit', String(limit));
        const qs = qp.toString();
        return { url: qs ? `/feedback-ratings?${qs}` : `/feedback-ratings`, method: 'GET' };
      },
      providesTags: ['CallingFeedback'],
    }),
    addCallingFeedback: builder.mutation<unknown, AddCallingFeedbackArgs>({
      query: (body) => ({ url: `/feedback-ratings`, method: 'POST', body }),
      invalidatesTags: ['CallingFeedback'],
    }),
  }),
});

export const { useGetCallingFeedbacksQuery, useAddCallingFeedbackMutation } = callingFeedbackApi;
